var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        'rms-app': _vm.generalOptions.app_id == 1,
        'rmb-app': _vm.generalOptions.app_id == 2,
        'rml-app': _vm.generalOptions.app_id == 5,
    },attrs:{"id":"app"}},[_c('div',{staticClass:"main-container full-width"},[_c('div',{staticClass:"router-container"},[_c('router-view')],1)]),_c('Footer',{class:{
            'admin-footer': _vm.is_admin,
        }})],1)}
var staticRenderFns = []

export { render, staticRenderFns }